<app-page-shell variant="report">
<div class="mobile-p0 dark-theme" [class.report-locked]="!reportAccessible">
    <div class="report-grid">
      <div>
        <div class="header">
          <div class="d-flex align-items-end justify-content-between header-title">
            <div>
              <h2 class="mb-0 title dark-text">{{report?.name}} SNÖBOARD</h2>
              @if (setStartDate && setEndDate) {
              <p class="dark-text report-date-range-text">From {{setStartDate | date:'dd-MM-yyyy'}} To {{setEndDate | date:'dd-MM-yyyy'}}</p>
              }
              <p class="dark-text">Keep on eye on your campaign's performance and start new ones.</p>
            </div>
            <div>
              @if (currentUser()?.can('index.all', 'project')) {
              <button class="btn-border mx-md-2 dark-btn" (click)="trackingAccuracy()">
                <i class="fa fa-tags fa-rotate-90" aria-hidden="true"></i>
                Conversion Tracking Accuracy
              </button>
              }
              <button class="btn-border dark-btn" (click)="shareReport()">
                <i class="fa fa-link fa-rotate-90" aria-hidden="true"></i>
                Share Report
              </button>
            </div>
          </div>
          @if (report?.lastSyncTime) {
          <div>
            Last Sync {{getLastSyncFormattedDate($safeNavigationMigration(report?.lastSyncTime))}}
          </div>
          }
        </div>
        <div class="select-date-campaign d-flex align-items-start justify-content-between flex-wrap pt-2">
          <div class="report-filter choose-capaign mb-0">
            <label class="dark-text">Choose a campaign</label>
            <div class="client-dropdown me-1">
              <app-creatable-select
                class="campaign-select dark-select"
                [selectedValue]="campaignId"
                [hideLabel]="true" [onlyBottomBorder]="false" [isCreatable]="false"
                [placeholder]="'Select a Campaign'" [selectOptions]="campaigns"
                (optionSelected)="campaignSelected($event)"></app-creatable-select>
            </div>
          </div>
          <div class="report-filter date-range mb-0">
            <app-sb-input-date-range class="report-date-range" label="Date Range"
              [start]="startDate" [end]="endDate" [presets]="reportPresets"
              (rangeChange)="onRangeChange($event)"></app-sb-input-date-range>
            <div class="chose-data-source mt-3">
              <div class="d-flex align-items-center justify-content-end">
                <p class="mb-0 me-2 dark-text">
                  Choose Data Source
                </p>
                <div class="action-check-box d-flex align-items-center">
                  <input type="checkbox" class="styled-checkbox" [checked]="mode === 'live'" (click)="modeSelected({value: mode === 'live' ? 'test' : 'live'})">
                  <label class="ms-2 dark-text">Live</label>
                </div>
                <div class="action-check-box d-flex align-items-center ms-2">
                  <input type="checkbox" class="styled-checkbox" [checked]="mode === 'test'" (click)="modeSelected({value: mode === 'test' ? 'live' : 'test'})">
                  <label class="ms-2 dark-text">Test</label>
                  <app-info-popover info="During the campaign creation, all state are collected as test data to not be mixed with real data"></app-info-popover>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div>
        <div class="filter d-flex align-items-center flex-wrap">
          <h3 class="dark-text">
            Filter By Segments:
          </h3>
          <div class="btn-action cursor-pointer"
               [class.selected-btn-action]="selectedChk['all']"
               (click)="changeChk('all', {target: {checked: !selectedChk['all']}})">
            All
          </div>
          @for (item of (this.segments || []); track item) {
          <div class="btn-action cursor-pointer"
               [class.selected-btn-action]="selectedChk[item.id]"
               (click)="changeChk(item.id, {target: {checked: !selectedChk[item.id]}})">
            {{item.name}}
          </div>
          }
        </div>
        <div class="filter filter-no-top d-flex align-items-center flex-wrap">
          <h3 class="dark-text">
            Filter By Influencer Type:
          </h3>
          <div class="btn-action cursor-pointer"
               [class.selected-btn-action]="selectedInfluencerTypes['all']"
               (click)="changeInfluencerType('all', {target: {checked: !selectedInfluencerTypes['all']}})">
            All
          </div>
          @for (item of (this.influencerTypes || []); track item) {
          <div class="btn-action cursor-pointer"
               [class.selected-btn-action]="selectedInfluencerTypes[item.id]"
               (click)="changeInfluencerType(item.id, {target: {checked: !selectedInfluencerTypes[item.id]}})">
            {{item.name}}
          </div>
          }
        </div>
        @if (activeReportTab === 'conversions') {
        <div class="filter filter-no-top d-flex align-items-center flex-wrap" data-report-time-to-register>
          <h3 class="dark-text">
            Registered In Less Than:
          </h3>
          <div ngbDropdown class="d-inline-block" container="body" autoClose="outside" #timeToRegisterDropdown="ngbDropdown">
            <button type="button" class="btn-action cursor-pointer" ngbDropdownToggle
                    [class.selected-btn-action]="!!timeToRegisterLt"
                    [attr.aria-label]="'Registered in less than: ' + timeToRegisterLabel(timeToRegisterLt)">
              {{ timeToRegisterLabel(timeToRegisterLt) }}
            </button>
            <div ngbDropdownMenu class="dropdown-menu">
              <app-time-to-register-filter [value]="timeToRegisterLt"
                (valueChange)="timeToRegisterSelected($event); timeToRegisterDropdown.close()"></app-time-to-register-filter>
            </div>
          </div>
        </div>
        }
      </div>
      <!-- After the filters, so both tabs answer to them. -->
      <div class="report-tabs">
        <app-sb-tabs [activeId]="activeReportTab" (activeIdChange)="onReportTabChange($event)">
          <ng-template sbTab="charts" title="Charts"></ng-template>
          <ng-template sbTab="conversions" title="Conversions"></ng-template>
        </app-sb-tabs>
      </div>
      @if (activeReportTab === 'conversions') {
      <div>
        <app-report-conversions
          [projectId]="projectId"
          [campaignId]="campaignId"
          [mode]="mode"
          [segmentIds]="selectedSegment"
          [influencerTypeIds]="influencerTypeId"
          [startDate]="startDate"
          [endDate]="endDate"
          [canExport]="!!currentUser()"
          [showMatchAccuracy]="!!currentUser()?.can('report-match-accuracy', 'project')"
          [timeToRegisterLt]="timeToRegisterLt"
          (exportRequest)="exportConversionsData($event)"></app-report-conversions>
      </div>
      }
      <!-- Hidden rather than removed: the advocate table, the graph and the charts keep their state. -->
      <div class="report-grid" [hidden]="activeReportTab !== 'charts'">
      <div>
        <div class="data-header">
          <div class="data-totals">
            <div class="card card-box data-details px-1 py-3">
              <div class="icon">
                <i class="fa fa-eye"></i>
              </div>
              <div class="title dark-text">Advocates</div>
              <div class="count">{{reportTotals?.influencers}}</div>
            </div>
            <div class="card card-box data-details px-1 py-3">
              <div class="icon">
                <i class="fa fa-inbox"></i>
              </div>
              <div class="title dark-text">Email Engagement</div>
              <div class="count simple">{{reportTotals?.emailsOpenRate.opened}}</div>
              <div class="count hover" title="Percentage of people who opened the sent emails">{{reportTotals?.emailsOpenRate.opened}}/<span class="font-percent">{{getEmailOpenRatePercentage(reportTotals)}}%</span></div>
            </div>
            <div class="card card-box data-details px-1 py-3">
              <div class="icon">
                <i class="fa fa-share-alt"></i>
              </div>
              <div class="title dark-text">Social Shares</div>
              <div class="count">{{reportTotals?.socialShares}}</div>
            </div>
            <div class="card card-box data-details px-1 py-3" [class.d-none]="(reportTotals && !(reportTotals.pageViews > 0) && !(reportTotals.pageViewsSkipped > 0))">
              <div class="icon">
                <i class="fa fa-eye"></i>
              </div>
              <div class="title dark-text">Views</div>
              <div class="count">{{reportTotals?.pageViews}}</div>
              @if (reportTotals?.pageViewsSkipped != null) {
              <div class="hover count-split">{{reportTotals.pageViews}} Page / {{reportTotals.pageViewsSkipped}} Skipped (Not counted)</div>
              }
            </div>
            <div class="card card-box data-details px-1 py-3">
              <div class="icon">
                <img src='./assets/Icons/referral-report.svg' height='15px' width='15px' alt='' style='margin-bottom: 13px'>
              </div>
              <div class="title dark-text">Referral Call to Action</div>
              <div class="count simple">{{reportTotals?.registrationClicks}}</div>
              <div class="count hover">{{reportTotals?.registrationClicks}}/<span class="font-percent">{{getCTARatePercentage(reportTotals)}}%</span></div>
              @if (reportTotals?.registrationClicksRedirect != null) {
              <div class="hover count-split">{{reportTotals.registrationClicksRedirect}} Via Widget / {{reportTotals.registrationClicksManual}} Via Landing Page</div>
              }
            </div>
            <div class="card card-box data-details px-1 py-3" [class.conversion-rate-card]="(reportTotals?.registerAveragePrice >= 0 && reportTotals?.registerAveragePrice * reportTotals?.referrals?.all <= 0)">
              <div class="icon simple">
                <img src='./assets/Icons/conversion-report.svg' alt='' height='21px' width='21px' style='margin-bottom: 7px'>
              </div>
              <div class="title simple dark-text">Conversions</div>
              <div class="icon hover">
                <i class="fas fa-hand-holding-usd"></i>
              </div>
              <div class="count simple">{{reportTotals?.referrals?.all}}</div>
              <span class="count simple font-percent">{{getReferralsRatePercentage(reportTotals)}}%</span>
              <div class="title hover dark-text">ROI</div>
              <div class="count hover">{{ formatRoi(reportTotals) }}</div>
            </div>
          </div>
        </div>
      </div>
      <div [hidden]="!referrals || !referrals?.length">
        <div class="card card-box snoball-effect">
          <div class="card-header d-flex align-items-center justify-content-between bg-white">
            <div class="effect-title dark-text">
              <i class="fa fa-snowflake-o" style="margin-right: 0.5rem;"></i>
              Snöball Effect
            </div>
            <div class="card-header--actions" id="filter_buttons">
              <button (click)="zoomIn()"
                      class="btn btn-sm me-1 btn btn-effect">
                <i class="fa fa-search-plus"></i>
              </button>
              <button (click)="zoomOut()"
                      class="btn btn-sm me-1 btn btn-effect">
                <i class="fa fa-search-minus"></i>
              </button>
            </div>
          </div>
          <div class="card-body" id="connectionHolder">
            <div id="mynetwork"></div>
            @if (!referrals || referrals.length === 0) {
            <div id="noData">
              <div class="no-data-msg dark-text">No Data Available</div>
            </div>
            }
            <div id="loadingBar">
              <div class="outerBorder">
                <div id="text">0%</div>
                <div id="border">
                  <div id="bar"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div [class.report-grid__half]="!showAllColumns" id="influencer-list">
        <div class="card card-box advocates">
          <div class="card-header d-flex flex-wrap align-items-center justify-content-between referral-id-card-header">
            <div class="card-header--title">
              <div class="advocates-title">
                <i class="fa fa-users" style="margin-right: 0.5rem; font-size: 14px"></i>
                @if (!selectedFromList) {
                <span class="dark-text">Advocates</span>
                }
                @if (selectedFromList) {
                <span class="dark-text">{{selectedFromList.name}}</span>
                }
                @if (selectedFromList) {
                <span class="cursor-pointer back-link" (click)="showAllInfluencers();">{{'<' + 'Back'}}</span>
                }
              </div>
            </div>
            <div class="advocates-check-box d-flex align-items-center">
              <div class="d-flex align-items-center mb-0">
                <input type='checkbox' [checked]="showAllColumns" (change)="showColumns($event)">
                <label>Advanced</label>
              </div>
              <div class="ms-4" >
                <img class="cursor-pointer ms-3 me-1 w-25" mat-icon-button [matMenuTriggerFor]="exportMenu"
                     src="../../assets/images/import-normal.png"> <label>Export</label>
                <mat-menu #exportMenu="matMenu" class="campaign-popover">
                  <a class="dropdown-item" (click)="exportAdvocatesData('csv')">
                    <i class="fa fa-file-o me-2"></i>CSV</a>
                  <a class="dropdown-item" (click)="exportAdvocatesData('xlsx')">
                    <i class="fa fa-file-excel-o me-2"></i>Excel (xlsx)</a>
                </mat-menu>
              </div>
            </div>
          </div>
          <div class="card-body">
            @if (selectedFromList) {
            <div class="row">
              <div class="col-sm-12">
                <div class="report-table-details">
                  <div class="d-flex p-0">
                    <h3 class="mb-0">
                      Details
                    </h3>
                    <span class="ng-clear-wrapper close-icon cursor-pointer" title="Close" (click)="showAllInfluencers(); selectedFromList = null"><span aria-hidden="true" class="ng-clear">×</span></span>
                  </div>
                  <div class="d-flex"><h6>Segment</h6><p>{{selectedFromList?.segment}}</p></div>
                  <div class="d-flex"><h6>Email</h6><p>{{selectedFromList?.email}}</p></div>
                  <div class="d-flex"><h6>Added</h6><p>{{_moment($safeNavigationMigration(selectedFromList?.created_at)).format('YYYY/MM/DD HH:mm')}}</p></div>
                  <div class="d-flex"><h6>Source</h6><p>{{selectedFromList?.source}}</p></div>
                  <div class="d-flex"><h6>Referral Tracker</h6>@if (currentUser()?.can('index.all', 'project')) {
<p>{{selectedFromList?.referredThroughTrackerSource}}</p>
}</div>
                  <div class="d-flex"><h6>Referred By</h6>@if (selectedFromList?.influencer?.referred) {
<p>{{selectedFromList?.influencer.referred.name}}{{selectedFromList?.referredByMedia ? (' via ' + selectedFromList?.referredByMedia) : ''}}</p>
}</div>
                  <div class="d-flex"><h6>Social Shares</h6><p>{{socialShareString}}</p></div>
                </div>
              </div>
            </div>
            }
            <div class="row advocate-table" [hidden]='isTableHide'>
              <div class="col-sm-12">
                <div class="custom-table" [class.open-selected]="!!selectedFromList && !showAllColumns">
                  @if (tableStarted()) {
                  <!-- A click on a row opens the advocate's details (onAdvocateRowClick). -->
                  <app-sb-table
                    [rows]="influencersList()"
                    [totalRows]="totalRows()"
                    [columns]="tableColumns"
                    [options]="tableOptions"
                    (stateChange)="onTableState($event)"
                    (click)="onAdvocateRowClick($event)">

                    <ng-template sbTableCell="name" let-influencer>
                      <p class="name m-0">{{influencer.name}}</p>
                      {{influencer?.company}}
                    </ng-template>
                    <ng-template sbTableCell="referred_count" let-influencer>
                      @if (influencer.referredCount !== 0) {
                        <a class="text-decoration: underline !important;" href="javascript:void(0)">{{influencer.referredCount}}</a>
                      }
                      @if (!influencer.referredCount || influencer.referredCount === 0) {{{influencer.referredCount}}}
                    </ng-template>
                    <ng-template sbTableCell="emailOpenStatus" let-influencer>{{influencer.emailOpenStatus > 0 || influencer.emailClickStatus > 0 ? 'Yes' : 'No'}}</ng-template>
                    <ng-template sbTableCell="emailClickStatus" let-influencer>{{influencer.emailClickStatus > 0 ? 'Yes' : 'No'}}</ng-template>
                    @for (network of shareNetworks; track network) {
                    <ng-template [sbTableCell]="'share_' + network" let-influencer>{{getSocialCount(influencer.id , network)}}</ng-template>
                    }
                    <ng-template sbTableCell="source" let-influencer>{{influencer.source || '-'}}</ng-template>
                    <ng-template sbTableCell="referredThroughTrackerSource" let-influencer>{{influencer.referredThroughTrackerSource || '-'}}</ng-template>
                    <ng-template sbTableCell="created_at" let-influencer>{{formatMoment(influencer.created_at) | tzDate : false : 'DD-MM-YYYY hh:mm a'}}</ng-template>
                    <ng-template sbTableCell="updated_at" let-influencer>{{formatMoment(influencer.updated_at) | tzDate : false : 'DD-MM-YYYY hh:mm a'}}</ng-template>
                    <ng-template sbTableCell="sessions" let-influencer>{{getSessionTitle(influencer)}}</ng-template>
                    <ng-template sbTableCell="badge_image_url" let-influencer>
                      @if (influencer.badge_image_url) {
                      <img [src]="influencer.badge_image_url" alt="Badge" style="max-height: 40px; max-width: 80px;">
                      }
                    </ng-template>
                  </app-sb-table>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="report-grid__half">
        <div class="card card-box advocates" [class.height-unset]="hideDiv.socialShare">
          <div class="card-header d-flex align-items-center justify-content-between referral-id-card-header">
            <div class="card-header--title card-header-containers">
              <div class="advocates-title">
                <i class="fa fa-share-alt" style="margin-right: 0.5rem;"></i>
                <span>Social Shares</span>
              </div>
              <div class="advocates-title cursor-pointer" (click)="hideDiv.socialShare = !hideDiv.socialShare">
                @if (!hideDiv.socialShare) {
                <i class="fa fa-minus" style="margin-right: 0.5rem;"></i>
                }
                @if (hideDiv.socialShare) {
                <i class="fa fa-plus" style="margin-right: 0.5rem;"></i>
                }
              </div>
            </div>
          </div>
          <div class="card-body align-items-center test-{{hideDiv.socialShare}}" [class.d-flex]="!hideDiv.socialShare" [hidden]='hideDiv.socialShare'>
            <div class="col-12">
              <div class="social-share-chart legend-center">
                <div id="piechart">
                  <apx-chart
                    [chart]="piechart.chart"
                    [labels]="piechart.labels"
                    [tooltip]="piechart.tooltip"
                    [dataLabels]="piechart.dataLabels"
                    [series]="piechart.series"
                    [colors]="piechart.colors"
                    [noData]="{text: 'No data available.'}"
                    [stroke]="{
                            width: 0
                          }"
                    [legend]="{
                            markers: {
                              width: 7,
                              height: 7,
                              offsetX: -10
                            },
                           fontWeight: 600,
                           fontSize: '12px'
                          }"
                    [responsive]="[
                            {
                              breakpoint: 1000,
                              options: {
                              legend: {
                                position: 'top',
                                 itemMargin: {
                                   horizontal: 10,
                                   vertical: 5
                                  },
                                  markers: {
                                  offsetX: -5
                                  }
                                },
                                 chart: {
                                  offsetY: 25
                                }
                              }
                            }
                          ]"
                  ></apx-chart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="report-grid__half">
        <div class="card card-box advocates" [class.height-unset]="hideDiv.conversions">
          <div class="card-header d-flex align-items-center justify-content-between referral-id-card-header">
            <div class="card-header--title card-header-containers">
              <div class="advocates-title">
                <i class="fa fa-eye" style="margin-right: 0.5rem;"></i>
                <span>Conversions Over Time by Segment</span>
                <app-info-popover info="Conversions per day, one line for each segment of the people who referred them."></app-info-popover>
              </div>
              <div class="advocates-title cursor-pointer" (click)="hideDiv.conversions = !hideDiv.conversions">
                @if (!hideDiv.conversions) {
                <i class="fa fa-minus" style="margin-right: 0.5rem;"></i>
                }
                @if (hideDiv.conversions) {
                <i class="fa fa-plus" style="margin-right: 0.5rem;"></i>
                }
              </div>
            </div>
          </div>
          <div class="card-body d-flex align-items-center" [class.d-flex]="!hideDiv.conversions" [hidden]='hideDiv.conversions'>
            @if (reportTotals) {
            <div class="card-body">
              <apx-chart
                [chart]="{type: 'line',height: '450'}"
                [dataLabels]="conversionsGraph.dataLabels"
                [xaxis]="conversionsGraph.xaxis"
                [yaxis]="conversionsGraph.yaxis"
                [tooltip]="conversionsGraph.tooltip"
                [series]="conversionsGraph.series"
                [noData]="{text: 'No data available.'}"
                [stroke]="{curve: 'smooth', show: true, width: 2}"
                [responsive]='[
                {
                  breakpoint: 1440,
                  options: {
                    plotOptions: {
                      bar: {
                      }
                    },
                    legend: {
                      position: "bottom",
                      itemMargin: {
                       horizontal: 10,
                       vertical: 10
                      }
                    }
                  }
                }
              ]'
              ></apx-chart>

            </div>
}
          </div>
        </div>
      </div>
      <div class="report-grid__half">
        <div class="card card-box advocates" [class.height-unset]="hideDiv.emailEngagement">
          <div class="card-header d-flex align-items-center justify-content-between referral-id-card-header">
            <div class="card-header--title card-header-containers">
              <div class="advocates-title">
                <i class="fa fa-inbox" style="margin-right: 0.5rem;"></i>
                <span>Email Engagement</span>
              </div>
              <div class="advocates-title cursor-pointer" (click)="hideDiv.emailEngagement = !hideDiv.emailEngagement">
                @if (!hideDiv.emailEngagement) {
                <i class="fa fa-minus" style="margin-right: 0.5rem;"></i>
                }
                @if (hideDiv.emailEngagement) {
                <i class="fa fa-plus" style="margin-right: 0.5rem;"></i>
                }
              </div>
            </div>
          </div>
          <div class="card-body align-items-center" [class.d-flex]="!hideDiv.emailEngagement" [hidden]='hideDiv.emailEngagement'>
            <div class="col-12">
              <div class="social-share-chart legend-center">
                <div id="radialBarChart">
                  <apx-chart
                    [chart]="{type: 'radialBar', height: '450' }"
                    [labels]="radialBar.labels"
                    [series]="radialBar.series"
                    [colors]="radialBar.colors"
                    [legend]="radialBar.legend"
                    [stroke]="radialBar.stroke"
                    [plotOptions]="radialBar.plotOptions"
                    [noData]="{text: 'No data available.'}"
                    [responsive]="radialBar.responsive"
                  ></apx-chart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="report-grid__half">
        <div class="card card-box advocates" [class.height-unset]="hideDiv.conversionsBySegment">
          <div class="card-header d-flex align-items-center justify-content-between referral-id-card-header">
            <div class="card-header--title card-header-containers">
              <div class="advocates-title">
                <i class="fa fa-pie-chart" style="margin-right: 0.5rem;"></i>
                <span>Conversions by Segment</span>
                <app-info-popover info="Each segment's share of the conversions, by the segment of the person who referred them. Shown as Type.Segment."></app-info-popover>
              </div>
              <div class="advocates-title cursor-pointer" (click)="hideDiv.conversionsBySegment = !hideDiv.conversionsBySegment">
                @if (!hideDiv.conversionsBySegment) {
                <i class="fa fa-minus" style="margin-right: 0.5rem;"></i>
                }
                @if (hideDiv.conversionsBySegment) {
                <i class="fa fa-plus" style="margin-right: 0.5rem;"></i>
                }
              </div>
            </div>
          </div>
          <div class="card-body align-items-center" [class.d-flex]="!hideDiv.conversionsBySegment" [hidden]='hideDiv.conversionsBySegment'>
            <div class="col-12">
              <div id="conversionsBySegmentChart">
                <apx-chart
                  [chart]="conversionsBySegmentPie.chart"
                  [labels]="conversionsBySegmentPie.labels"
                  [series]="conversionsBySegmentPie.series"
                  [colors]="conversionsBySegmentPie.colors"
                  [dataLabels]="conversionsBySegmentPie.dataLabels"
                  [tooltip]="conversionsBySegmentPie.tooltip"
                  [legend]="conversionsBySegmentPie.legend"
                  [noData]="{text: 'No data available.'}"
                ></apx-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="report-grid__half">
        <div class="card card-box advocates" [class.height-unset]="hideDiv.conversionsByCampaignType">
          <div class="card-header d-flex align-items-center justify-content-between referral-id-card-header">
            <div class="card-header--title card-header-containers">
              <div class="advocates-title">
                <i class="fa fa-pie-chart" style="margin-right: 0.5rem;"></i>
                <span>Conversions by Campaign Type</span>
                <app-info-popover info="Each campaign type's share of the conversions: the influencer type selected on the campaign that brought them in."></app-info-popover>
              </div>
              <div class="advocates-title cursor-pointer" (click)="hideDiv.conversionsByCampaignType = !hideDiv.conversionsByCampaignType">
                @if (!hideDiv.conversionsByCampaignType) {
                <i class="fa fa-minus" style="margin-right: 0.5rem;"></i>
                }
                @if (hideDiv.conversionsByCampaignType) {
                <i class="fa fa-plus" style="margin-right: 0.5rem;"></i>
                }
              </div>
            </div>
          </div>
          <div class="card-body align-items-center" [class.d-flex]="!hideDiv.conversionsByCampaignType" [hidden]='hideDiv.conversionsByCampaignType'>
            <div class="col-12">
              <div id="conversionsByCampaignTypeChart">
                <apx-chart
                  [chart]="conversionsByCampaignTypePie.chart"
                  [labels]="conversionsByCampaignTypePie.labels"
                  [series]="conversionsByCampaignTypePie.series"
                  [colors]="conversionsByCampaignTypePie.colors"
                  [dataLabels]="conversionsByCampaignTypePie.dataLabels"
                  [tooltip]="conversionsByCampaignTypePie.tooltip"
                  [legend]="conversionsByCampaignTypePie.legend"
                  [noData]="{text: 'No data available.'}"
                ></apx-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="card card-box advocates">
          <div class="card-header d-flex align-items-center bg-white">
            <div class="card-header--title card-header-containers">
              <div class="advocates-title">
                <i class="fa fa-eye" style="margin-right: 0.5rem;"></i>
                <span>Landing Page Impression</span>
              </div>
              <div class="advocates-title cursor-pointer" (click)="hideDiv.landingPageViews = !hideDiv.landingPageViews">
                @if (!hideDiv.landingPageViews) {
                <i class="fa fa-minus" style="margin-right: 0.5rem;"></i>
                }
                @if (hideDiv.landingPageViews) {
                <i class="fa fa-plus" style="margin-right: 0.5rem;"></i>
                }
              </div>
            </div>
          </div>
          @if (reportTotals) {
          <div class="card-body h-auto" [hidden]='hideDiv.landingPageViews'>
            <apx-chart
              [chart]="{type: 'line',height: '450'}"
              [dataLabels]="{enabled: false}"
              [xaxis]="{
                      type: 'category',
                      title: {text: 'Dates',style: {
                        cssClass: 'report-barchart-title'
                      }},
                      label: {show: true},
                      tickAmount: 15,
                      categories: dates,
                      axisTicks: {
                          show: true,
                          borderType: 'solid',
                          color: '#78909C',
                          height: 6,
                          offsetX: 0,
                          offsetY: 0
                        }
                      }"
              [yaxis]="{
                        type: '',
                        show: true,
                        showAlways: true,
                        title: {
                          text: 'Page Views'
                        }
                      }"
              [tooltip]="{enabled: true, shared: true}"
              [series]="series"
              [noData]="{text: 'No data available.'}"
              [stroke]="{curve: 'smooth', show: true, width: 2}"
              [responsive]='[
                    {
                      breakpoint: 1440,
                      options: {
                        plotOptions: {
                          bar: {
                          }
                        },
                        legend: {
                          position: "bottom",
                          itemMargin: {
                           horizontal: 10,
                           vertical: 10
                          }
                        }
                      }
                    }
                  ]'
            ></apx-chart>

          </div>
}
        </div>
      </div>
      @if (false) {
      <div>
        <div class="card card-box advocates">
          <div class="card-header d-flex align-items-center bg-white">
            <div class="card-header--title">
              <div class="advocates-title">
                <i class="fa fa-share-alt" style="margin-right: 0.5rem;"></i>
                <span>Some Social Shares</span>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="advocates-check-box d-flex align-items-center">
              <div class="d-flex align-items-center m-0">
                <input type='checkbox'>
                <label>All</label>
              </div>
              <div class="d-flex align-items-center mb-0">
                <input type='checkbox'>
                <label>Twitter</label>
              </div>
              <div class="d-flex align-items-center mb-0">
                <input type='checkbox'>
                <label>facebook</label>
              </div>
            </div>
            <div class="img-wrapper social-share-holder">
              <img src="./assets/images/dummy-social-shares.png" class="img-fluid"/>
            </div>
          </div>
        </div>
      </div>
      }
      <div class="report-grid__half">
        <div class="card card-box advocates" [class.height-unset]="hideDiv.shareMediaTypes">
          <div class="card-header d-flex align-items-center justify-content-between referral-id-card-header">
            <div class="card-header--title card-header-containers">
              <div class="advocates-title">
                <i class="fa fa-picture-o" style="margin-right: 0.5rem;"></i>
                <span>Shared Media Type</span>
              </div>
              <div class="advocates-title cursor-pointer" (click)="hideDiv.shareMediaTypes = !hideDiv.shareMediaTypes">
                @if (!hideDiv.shareMediaTypes) {
                <i class="fa fa-minus" style="margin-right: 0.5rem;"></i>
                }
                @if (hideDiv.shareMediaTypes) {
                <i class="fa fa-plus" style="margin-right: 0.5rem;"></i>
                }
              </div>
            </div>
          </div>
          <div class="card-body align-items-center" [class.d-flex]="!hideDiv.shareMediaTypes" [hidden]='hideDiv.shareMediaTypes'>
            <div class="col-12">
              <div class="social-share-chart legend-center">
                <div id="shareMediaChart">
                  <apx-chart
                    [chart]="{type: 'radialBar', height: '450' }"
                    [labels]="shareMediaRadialBar.labels"
                    [series]="shareMediaRadialBar.series"
                    [colors]="shareMediaRadialBar.colors"
                    [legend]="shareMediaRadialBar.legend"
                    [plotOptions]="shareMediaRadialBar.plotOptions"
                    [noData]="{text: 'No data available.'}"
                    [responsive]="shareMediaRadialBar.responsive"
                  ></apx-chart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="report-grid__half">
        <div class="card card-box advocates" [class.height-unset]="hideDiv.sharesByCountry">
          <div class="card-header d-flex align-items-center justify-content-between referral-id-card-header">
            <div class="card-header--title card-header-containers">
              <div class="advocates-title">
                <i class="fa fa-globe" style="margin-right: 0.5rem;"></i>
                <span>Shares by Country</span>
              </div>
              <div class="advocates-title cursor-pointer" (click)="toggleSharesByCountry()">
                @if (!hideDiv.sharesByCountry) {
                <i class="fa fa-minus" style="margin-right: 0.5rem;"></i>
                }
                @if (hideDiv.sharesByCountry) {
                <i class="fa fa-plus" style="margin-right: 0.5rem;"></i>
                }
              </div>
            </div>
          </div>
          <div class="card-body" [hidden]='hideDiv.sharesByCountry'>
            <div class="shares-map-holder">
              <div #sharesMap class="shares-map"></div>
              @if (!hasSharesByCountry) {
              <div class="shares-map-empty">No data available.</div>
              }
            </div>
            @if (sharesNotOnMap.length) {
            <div class="shares-not-on-map">
              <strong>Not on the map:</strong>
              @for (country of sharesNotOnMap; track country.name; let last = $last) {
              {{country.name}} ({{country.count}}){{last ? '' : ', '}}
              }
            </div>
            }
          </div>
        </div>
      </div>
      <div>
        <div class="card card-box advocates" [class.height-unset]="hideDiv.preferenceInsights">
          <div class="card-header d-flex align-items-center justify-content-between referral-id-card-header">
            <div class="card-header--title card-header-containers">
              <div class="advocates-title">
                <i class="fa fa-sliders" style="margin-right: 0.5rem;"></i>
                <span>Influencer Privacy Preference Insights</span>
              </div>
              <div class="advocates-title cursor-pointer" (click)="hideDiv.preferenceInsights = !hideDiv.preferenceInsights">
                @if (!hideDiv.preferenceInsights) {
                <i class="fa fa-minus" style="margin-right: 0.5rem;"></i>
                }
                @if (hideDiv.preferenceInsights) {
                <i class="fa fa-plus" style="margin-right: 0.5rem;"></i>
                }
              </div>
            </div>
          </div>
          <div class="card-body" [hidden]='hideDiv.preferenceInsights'>
            @if (!reportTotals) {
            <div class="text-center py-4">
              <div class="spinner-border text-primary" role="status"></div>
            </div>
            }
            @if (reportTotals) {
              <div class="row text-center mb-3 preference-insights-kpis">
                <div class="col-6 col-md-3 col-lg mb-2">
                  <div class="fw-bold">{{reportTotals.preferenceInsights?.updatedPreferences || 0}}</div>
                  <div class="preference-insights-kpi-label">Updated preferences</div>
                </div>
                <div class="col-6 col-md-3 col-lg mb-2">
                  <div class="fw-bold">{{reportTotals.preferenceInsights?.dataRemoval || 0}}</div>
                  <div class="preference-insights-kpi-label">Data removal</div>
                </div>
                <div class="col-6 col-md-3 col-lg mb-2">
                  <div class="fw-bold">{{reportTotals.preferenceInsights?.marketingEmailOptOut || 0}}</div>
                  <div class="preference-insights-kpi-label">Marketing email opt-out</div>
                </div>
                <div class="col-6 col-md-3 col-lg mb-2">
                  <div class="fw-bold">{{reportTotals.preferenceInsights?.allEmailOptOut || 0}}</div>
                  <div class="preference-insights-kpi-label">All email opt-out</div>
                </div>
                <div class="col-6 col-md-3 col-lg mb-2">
                  <div class="fw-bold">{{reportTotals.preferenceInsights?.emailFrequencySet || 0}}</div>
                  <div class="preference-insights-kpi-label">Email Custom Frequency</div>
                </div>
                <div class="col-6 col-md-3 col-lg mb-2">
                  <div class="fw-bold">{{reportTotals.preferenceInsights?.noEmailOpenTracking || 0}}</div>
                  <div class="preference-insights-kpi-label">No email open tracking</div>
                </div>
                <div class="col-6 col-md-3 col-lg mb-2">
                  <div class="fw-bold">{{reportTotals.preferenceInsights?.noTracking || 0}}</div>
                  <div class="preference-insights-kpi-label">No tracking</div>
                </div>
              </div>
              @if (preferenceInsightsChart.annotations?.xaxis?.length) {
              <div class="text-end mb-2">
                <label class="cursor-pointer mb-0" style="font-size: 0.85rem;">
                  <input type="checkbox" [checked]="showCampaignLaunchLabels" (change)="toggleCampaignLaunchLabels()">
                  Show campaign launch labels
                </label>
              </div>
              }
              @if (preferenceInsightsChart.categories?.length) {
              <apx-chart
                [chart]="{type: 'line', height: '350', toolbar: {show: true}, events: {mounted: onPreferenceChartRender, updated: onPreferenceChartRender}}"
                [dataLabels]="{enabled: false}"
                [colors]="preferenceInsightsChart.colors"
                [legend]="{position: 'top', horizontalAlign: 'center'}"
                [markers]="{size: 4}"
                [annotations]="preferenceInsightsChart.annotations"
                [xaxis]="{
                  type: 'datetime',
                  min: preferenceInsightsChart.xMin,
                  max: preferenceInsightsChart.xMax,
                  labels: {datetimeUTC: false, format: 'dd MMM'},
                  title: {text: 'Last updated (' + preferenceInsightsDateLabel + ')'}
                }"
                [yaxis]="{title: {text: 'Preferences'}, min: 0}"
                [tooltip]="{enabled: true, shared: true}"
                [series]="preferenceInsightsChart.series"
                [stroke]="{curve: 'smooth', width: 2}"
                [noData]="{text: 'No preference activity for the selected report filters.'}"
              ></apx-chart>
              }
              @if (!preferenceInsightsChart.categories?.length) {
              <div class="preference-insights-empty text-center py-3">
                No preference activity for the selected report filters.
              </div>
              }
            }
          </div>
        </div>
      </div>
      <div [hidden]="!selectedProject?.report_analysis">
        <div class="card card-box advocates">
          <div class="card-header d-flex align-items-center bg-white">
            <div class="card-header--title card-header-containers">
              <div class="advocates-title">
                <i class="fa fa-file" style="margin-right: 0.5rem;"></i>
                <span>Summary/Recommendations</span>
              </div>
              <div class="advocates-title cursor-pointer" (click)="hideDiv.summary = !hideDiv.summary">
                @if (!hideDiv.summary) {
                <i class="fa fa-minus" style="margin-right: 0.5rem;"></i>
                }
                @if (hideDiv.summary) {
                <i class="fa fa-plus" style="margin-right: 0.5rem;"></i>
                }
              </div>
            </div>
          </div>
          <div class="card-body" [hidden]='hideDiv.summary'>
            <div class="summary-report">
              <iframe #iframe style="border: none; width: 100%; height: auto"></iframe>
              <!--&lt;!&ndash;                This campaign has shown fair engagement.&ndash;&gt;-->
              @if (false) {
              <a href="#" class="talk-btn">
                <i class="fa fa-comment" aria-hidden="true"></i>
                Talk to us about this recommendation
              </a>
              }
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>

    <!--                      Ask Email-->
    <!--                      <div-->
    <!--                        <div-->
    <!--                          class="card card-box card-box-border-bottom card-shadow-info mb-1">-->
    <!--                                         label="Open"-->
    <!--                                         class="mt-1 img-fluid ngx-gauge-meter"-->
    <!--                                         min="0" role="slider" size="120" thick="6" type="full"-->
    <!--                                         aria-label="" style="width: 120px; height: 120px;">-->
    <!--                                  class="reading-affix">-->
    <!--                                         label="Click"-->
    <!--                                         class="mt-1 img-fluid ngx-gauge-meter"-->
    <!--                                         min="0" role="slider" size="120" thick="6" type="full"-->
    <!--                                         aria-label="" style="width: 120px; height: 120px;">-->
    <!--                                  class="reading-affix">-->
    <!--                             style="font-size: 2rem;margin-right: 0.5rem; vertical-align: bottom;"-->
    <!--                          click to clear influencer-->
    <!--                        <div-->
    <!--                          class='col-md-12 mb-3 mx-auto customize-email d-flex align-items-center justify-content-between'>-->
    <!--                              <th-->
    <!--                                Influencer Type-->
    <!--                              <th-->
    <!--                                Email-->
    <!--                              <th-->
    <!--                                Booth Number-->
    <!--&lt;!&ndash;                              <th&ndash;&gt;-->
    <!--&lt;!&ndash;                                Company&ndash;&gt;-->
    <!--                              <th-->
    <!--                                First Name-->
    <!--                              <th-->
    <!--                                Last Name-->
    <!--                              <th-->
    <!--                                Job Title-->
    <!--                              <th-->
    <!--                                Phone-->
    <!--                              <th-->
    <!--                                Registration url-->
    <!--                              <th-->
    <!--                                Sessions-->
    <!--                              <th-->
    <!--                                Slug-->
    <!--                              <th-->
    <!--                                Video url-->
    <!--                              <th-->
    <!--                                Custom 1-->
    <!--                              <th-->
    <!--                                Custom 2-->
    <!--                              <th-->
    <!--                                Custom 3-->
    <!--                              <th-->
    <!--                                Custom 4-->
    <!--                              <th-->
    <!--                                Custom 5-->
    <!--                              <th-->
    <!--                                Custom 6-->
    <!--                              <th-->
    <!--                                Custom 7-->
    <!--                              <th-->
    <!--                                Custom 8-->
    <!--                              <th-->
    <!--                                Custom 9-->
    <!--                              <th-->
    <!--                                Custom 10-->
    <!--                                <ng-container-->
    <!--                              <td-->
    <!--                              <td-->
    <!--                              <td-->
    <!--&lt;!&ndash;                              <td&ndash;&gt;-->
    <!--                              <td-->
    <!--                              <td-->
    <!--                              <td-->
    <!--                              <td-->
    <!--                              <td-->
    <!--                              <td-->
    <!--                              <td-->
    <!--                              <td-->
    <!--                              <td-->
    <!--                              <td-->
    <!--                              <td-->
    <!--                              <td-->
    <!--                              <td-->
    <!--                              <td-->
    <!--                              <td-->
    <!--                              <td-->
    <!--                              <td-->
    <!--                              <td-->
    <!--                              <td-->
    <!--                                No data found-->
    <!--                      Page Views-->
    <!--                    <apx-chart-->
    <!--                      type: 'category',-->
    <!--                      title: {text: 'Dates'},-->
    <!--                      label: {show: true},-->
    <!--                      tickAmount: 15,-->
    <!--                      categories: dates,-->
    <!--                      axisTicks: {-->
    <!--                          show: true,-->
    <!--                          borderType: 'solid',-->
    <!--                          color: '#78909C',-->
    <!--                          height: 6,-->
    <!--                          offsetX: 0,-->
    <!--                          offsetY: 0-->
    <!--                        }-->
    <!--                      }"-->
    <!--                        type: '',-->
    <!--                        show: true,-->
    <!--                        showAlways: true,-->
    <!--                        title: {-->
    <!--                          text: 'Page Views'-->
    <!--                        }-->
    <!--                      }"-->

    <!--                      Social Share-->
    <!--                      <apx-chart-->
    <!--                            enable: true,-->
    <!--                            formatter: chartLabelFormatter,-->
    <!--                            textAnchor: 'end'-->

    <!--                        }"-->
  </div>
</app-page-shell>
<ng-template #passwordForm let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-title">Enter password to view report</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <div class="floating-label">
          <input class="floating-input" [(ngModel)]="reportPassword" (ngModelChange)="reportPasswordError.set('')"
                 placeholder=" " type="password"/>
          <span class="highlight"></span>
          <label>Password</label>
          @if (reportPasswordError()) {
          <div class="bar error-brd">
            <div class="invalid-text">{{reportPasswordError()}}</div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
  <input type="hidden" ngbAutofocus>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" [disabled]="reportPasswordPending()" (click)="validatePassword(modal)">
      @if (reportPasswordPending()) {
      <i class="fa fa-spinner fa-spin me-2" aria-hidden="true"></i>
}Confirm
    </button>
  </div>
</ng-template>


<ng-template #loadReport let-modal >
  <div class="modal-body">
    <div class="text-center pb-3">
      <div class="lds-ellipsis align-items-center justify-content-center" style='right: 20px'>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class='pt-2'>
        <h3>please wait</h3>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #csvDownload let-modal >
  <div class="modal-header">
    <h4
      class="modal-title"
      id="modal-title"
    >
      Export {{ !csvDownloadComplete() ? ': Your data is being exported' : ''}}
    </h4>
    <div class="d-flex justify-content-end">
      <button
        type="button"
        aria-label="Close button"
        class="btn-close"
        aria-describedby="modal-title"
        (click)="modal.close()"
      ></button>
    </div>
  </div>
  <div class="modal-body">
    <div class="text-center">
      @if (!csvDownloadComplete() && exportProgress().status !== 'failed') {
      <button class="btn btn-default" type="button">
        <span class="btn-wrapper--icon spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <span class="btn-wrapper--label">
      {{exportProgress().status === 'started' ?
          'Export: started' :
          exportProgress().status === 'in-progress' ?
            'Exporting: ' + exportProgress().progress + '%' + (exportProgress().remainingTimeFormatted ? ' — remains ' + exportProgress().remainingTimeFormatted : '') :
            'Export: ' + exportProgress().status}}
    </span>
      </button>
      }
      @if (exportProgress().status === 'failed') {
      <div>
        <p class="text-danger mb-3">Export failed. Please try again.</p>
        <button class="btn btn-default" type="button" (click)="exportModelRef.close()">Close</button>
      </div>
      }
      @if (csvDownloadComplete()) {
      <a class="btn btn-default" type="button" (click)="downloadExportFile()">
        <span class="btn-wrapper--label">
          {{'File Link'}}
    </span>
      </a>
      }

    </div>
  </div>
</ng-template>
